module.exports = __webpack_public_path__ + "static/media/fourWarriors-1.061af924.png";